import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NewsItem } from "@ha/data/basic";
import { Observable, of } from "rxjs";

import { Home } from "../models/home.model";

@Injectable({ providedIn: "root" })
export class HomeService {
    constructor(private httpClient: HttpClient) {}

    public data() {
        return this.httpClient.get<Home>("/api/home/data");
    }

    public getNews(): Observable<NewsItem[]> {
        const newsItems: NewsItem[] = [{
            heading: [{
                language: "sv",
                text: "Skriv tillstånd digitalt här i appen",
            }, {
                language: "en",
                text: "Write digital permit here in the app",
            }],
            body: [{
                language: "sv",
                text:
                    "Att skriva tillstånd digitalt är både enklare och mer hållbart. Allt du behöver finns här i appen. Tryck för att komma till den digitala tillståndslistan.",
            }, {
                language: "en",
                text:
                    "Writing digital permits is both easier and more sustainable. Everything you need is here in the app. Press to access the digital permit.",
            }],
            icon: "ballot-check",
            color: "blue",
            url: ["permit"],
        }, {
            heading: [{
                language: "sv",
                text: "Digital tillståndshantering för företaget",
            }, {
                language: "en",
                text: "Digital permit management for the company",
            }],
            body: [{
                language: "sv",
                text:
                    `<p>Behöver ditt företag överblick över alla heta arbeten i verksamheten eller har behov att anpassa tillståndslistan efter risker och specifika krav?</p>
                    <p>Då är <b>Heta Arbeten<sup>®</sup> PREMIUM </b>svaret! Läs mer om vår företagstjänst och boka en demo här!</p>`,
            }, {
                language: "en",
                text:
                `<p>Does your company need an overview of all hot work in the business or does it need to adapt the permit according to risks and specific requirements?</p>
                <p>Then <b>Heta Arbeten<sup>®</sup> PREMIUM </b>is the answer! Read more about our business service and book a demo here!</p>`,
            }],
            icon: "gem",
            color: "blue",

            url: "https://www.hetaarbeten.se/sv/digitala-tjanster/heta-arbeten-premium/",

        }];


        return of(newsItems);
    }
}
